import { clsx } from 'clsx';
import * as React from 'react';

import * as styles from './CarouselPhoto.css';

interface ICarouselPhotoProps {
  src: string;
  lazy: boolean;
}

export const CarouselPhoto = React.memo(({ src, lazy }: ICarouselPhotoProps) => {
  return (
    <div className={styles['container']}>
      <div
        className={clsx(styles['blur-bg'], lazy && 'lazyload')}
        data-bg={src}
        style={{ backgroundImage: !lazy ? `url(${src}) ` : undefined }}
      />
      <div className={styles['image']}>
        <img className="lazyload" data-src={src} />
      </div>
    </div>
  );
});

CarouselPhoto.displayName = 'CarouselPhoto';
